import * as React from "react";
import { Routes, Route } from 'react-router-dom';
import Layout from "views/layouts";
import Home from "views/pages/Home";
import NotFound from "views/pages/NotFound";
import { AllTeams, TeamDetails } from "views/pages/team/index.js";
import { AllTournaments, TournamentDetails } from "views/pages/tournament";
import { AllPlayers, PlayerDetails } from "views/pages/player";
import Login from "views/pages/login/Login";
import ForgotPassword from "views/pages/login/forgotpwd";
import SignUp from "views/pages/login/signup";
import BriefScore from "views/pages/scoring/briefscore";
import TempHome from "views/pages/TempHome";
import MatchScoreCard from "views/pages/match/details";
import TargetCalculator from "views/pages/tools/target";
import WeightedScoreCalculator from "views/pages/tools/weighted";
import Head2Head from "views/pages/plan/head2head";
import HelpDocumentation from "views/pages/handbook";
import LiveStreamingTicker from "views/pages/live/streaming";
import LiveCoverage from "views/pages/live/coverage/LiveCoverage";
import NoLayout from "views/layouts/nolayout";
import Grounds from "views/pages/grounds";

const Navigation = () => {

    return (
        <Routes>
            <Route
                path="/"
                exact
                element={
                    <Layout>
                        <TempHome />
                    </Layout>
                }
            />
            <Route
                path="/teams"
                exact
                element={
                    <Layout>
                        <AllTeams />
                    </Layout>
                }
            />
            <Route
                path="/teams/:teamSlug"
                exact
                element={
                    <Layout>
                        <TeamDetails />
                    </Layout>
                }
            />
            <Route
                path="/players"
                exact
                element={
                    <Layout>
                        <AllPlayers />
                    </Layout>
                }
            />
            <Route
                path="/players/:playerSlug"
                exact
                element={
                    <Layout>
                        <PlayerDetails />
                    </Layout>
                }
            />
            <Route
                path="/tournaments"
                exact
                element={
                    <Layout>
                        <AllTournaments />
                    </Layout>
                }
            />
            <Route
                path="/tournaments/:tournamentSlug"
                exact
                element={
                    <Layout>
                        <TournamentDetails />
                    </Layout>
                }
            />
            <Route
                path="/match/:matchSlug"
                exact
                element={
                    <Layout>
                        <MatchScoreCard />
                    </Layout>
                }
            />
         
         <Route
                path="/research-and-plan/head-to-head"
                exact
                element={
                    <Layout>
                        <Head2Head />
                    </Layout>
                }
            />

            <Route
                path="/tools/target-calculator"
                exact
                element={
                    <Layout>
                        <TargetCalculator />
                    </Layout>
                }
            />
            <Route
                path="/tools/weighted-score-calculator"
                exact
                element={
                    <Layout>
                        <WeightedScoreCalculator />
                    </Layout>
                }
            />
            <Route
                path="/login"
                exact
                element={
                    <Layout>
                        <Login />
                    </Layout>
                }
            />
            <Route
                path="/signup"
                exact
                element={
                    <Layout>
                        <SignUp />
                    </Layout>
                }
            />
            <Route
                path="/forgotpassword"
                exact
                element={
                    <Layout>
                        <ForgotPassword />
                    </Layout>
                }
            />
            <Route
                path="/briefscore"
                exact
                element={
                    <Layout>
                        <BriefScore />
                    </Layout>
                }
            />
            <Route
                path="/grounds"
                exact
                element={
                    <Layout>
                        <Grounds />
                    </Layout>
                }
            />
            <Route
                path="/help"
                exact
                element={
                    <Layout>
                        <HelpDocumentation />
                    </Layout>
                }
            />
            <Route 
                path="/live/streaming/:matchId"
                element={
                    <NoLayout>
                        <LiveStreamingTicker />
                    </NoLayout>
                }
                />
            <Route 
                path="/live/coverage/:matchId"
                element={
                    <Layout>
                        <LiveCoverage />
                    </Layout>
                }
                />
            <Route path="*" element={
                <Layout>
                    <NotFound />
                </Layout>
            } />
        </Routes>
    )
};
export default Navigation;

